// ABOUTME: The Marketing thread's agent runs that took at least one step, for their activity
// rows. The event stream refreshes them on every agent_run_* notification (useEventStream).
import { useQuery } from '@tanstack/react-query'
import { AGENT_RUN_ACTIVITY_KEY, listChannelRuns, type AgentRun } from '@/api/agentRuns'

const IN_APP = 'in_app'
const NONE: AgentRun[] = []

export function useThreadRuns(): AgentRun[] {
  const { data } = useQuery({
    queryKey: [AGENT_RUN_ACTIVITY_KEY, IN_APP],
    queryFn: () => listChannelRuns(IN_APP),
    select: (runs) => runs.filter((run) => run.steps.length > 0),
  })
  return data ?? NONE
}
